interface Props {
  label?:       string;
  type?:        string;
  value:        string;
  onChange:     (v: string) => void;
  placeholder?: string;
  hint?:        string;
  error?:       string | null;
  required?:    boolean;
}

export default function Input({ label, type="text", value, onChange, placeholder, hint, error, required }: Props) {
  return (
    <div className="mb-4">
      {label && <label className="block text-sm font-medium text-slate-700 mb-1.5">{label}</label>}
      <input
        type={type} value={value} placeholder={placeholder}
        onChange={e => onChange(e.target.value)}
        className={`w-full px-3 py-2.5 border rounded-lg text-sm text-slate-800 outline-none bg-white
          ${error ? "border-red-400 focus:border-red-500" : "border-slate-300 focus:border-emerald-500"}`}
        required={required}
      />
      {hint  && <p className="text-xs text-slate-400 mt-1">{hint}</p>}
      {error && <p className="text-xs text-red-600 mt-1">{error}</p>}
    </div>
  );
}
